import { Table, type TableColumnsType } from 'antd'

import type { GpuSchemas } from '@/api/gpu/client'
import { FormattedDate } from '@/components/common/FormattedDate'
import { UserEmailLink } from '@/components/common/UserEmailLink'

import { usePagePagination } from '../components/pagePagination'
import { describeEntry } from '../history'
import { useAkashBlockHistory } from '../hooks/useAkashBlockHistory'

type Entry = GpuSchemas['BlockHistoryView']

const columns: TableColumnsType<Entry> = [
  {
    title: 'When',
    dataIndex: 'changed_at',
    width: 180,
    render: (date: string) => (
      <FormattedDate date={date} fmt="MMM d, yyyy HH:mm" />
    ),
  },
  {
    title: 'Who',
    dataIndex: 'author',
    width: 220,
    render: (author: string) => <UserEmailLink userId={author} />,
  },
  {
    title: 'Change',
    key: 'change',
    render: (_, entry) => describeEntry(entry, 'inherited').join('; '),
  },
]

export function BlockHistory() {
  const { query, pagination } = usePagePagination()
  const { data, isFetching, error } = useAkashBlockHistory(query)

  return (
    <Table<Entry>
      rowKey="id"
      dataSource={data?.items}
      columns={columns}
      loading={isFetching}
      pagination={pagination(data?.pagination)}
      size="small"
      locale={{
        emptyText: error ? error.message : 'No block changes yet',
      }}
    />
  )
}
